import { t } from 'i18next';

import { ADDRESS_TYPES } from '~constants/address';

export const FIELDS = {
  note: 'dispatchNote',
  apartment: 'apartmentDetails',
  textAddress: 'textAddress'
};

export const STREET_NUMBER = 'street_number';

export const BUILDING_TYPE_OPTIONS = [
  {
    name: t('Profile:home'),
    value: 0,
    type: ADDRESS_TYPES.HOME
  },
  {
    name: t('Profile:work'),
    value: 1,
    type: ADDRESS_TYPES.WORK
  },
  {
    name: t('Profile:couple'),
    value: 2,
    type: ADDRESS_TYPES.COUPLE
  },
  {
    name: t('Profile:other'),
    value: 3,
    type: ADDRESS_TYPES.OTHER
  }
];
